import React from 'react'

export default function ComingSoon({ clubName, logoUrl, headline, body, heroImageUrl, settings } = {}) {
  const safeSettings = settings && typeof settings === 'object' ? settings : {}
  const safeAddress = safeSettings.address && typeof safeSettings.address === 'object' ? safeSettings.address : {}

  const safeClubName = clubName || safeSettings.clubName || 'your club'
  const safeLogo = logoUrl || safeSettings.logoUrl || null
  const safeHero = heroImageUrl || safeSettings.heroImageUrl || null
  const initials = safeClubName ? safeClubName.slice(0, 1).toUpperCase() : 'C'
  const subtitle = body || safeSettings.body || 'We are busy crafting this experience for your members.'
  const heading = headline || safeSettings.headline || 'Coming soon'
  const street = safeAddress.street || ''
  const city = safeAddress.city || ''
  const state = safeAddress.state || ''
  const postcode = safeAddress.postcode || ''
  const formattedAddress = [street, city, state, postcode].filter(Boolean).join(', ')

  return (
    <div className="coming-soon-shell">
      <header className="member-topbar">
        <div className="topbar-left">
          {safeLogo ? (
            <img src={safeLogo} alt={`${safeClubName} logo`} />
          ) : (
            <div className="logo-placeholder" aria-hidden>
              {initials}
            </div>
          )}
          <div className="club-name">{safeClubName}</div>
        </div>
        <div className="topbar-right">
          <span className="pill-label">Member Portal</span>
        </div>
      </header>
      <main className="coming-soon-content">
        <section className="member-card coming-soon-card">
          <div className="hero-grid">
            <div>
              <div className="hero-label">Members Portal</div>
              <div className="hero-heading">{heading}</div>
              <div className="hero-subtext">{subtitle}</div>
              {formattedAddress ? (
                <div className="hero-subtext text-xs text-gray-500 mt-2">{formattedAddress}</div>
              ) : null}
            </div>
            {safeHero ? (
              <div className="hero-image">
                <img src={safeHero} alt="Club" />
              </div>
            ) : null}
          </div>
        </section>
      </main>
    </div>
  )
}
